import {BasicPersonalDataModel} from './basic-personal-data.model';
import {AddressModel} from './address-model';

export class PersonalDataModel {
  basicPersonalDataModel: BasicPersonalDataModel;
  address: AddressModel;

  constructor() {
    this.basicPersonalDataModel = new BasicPersonalDataModel();
    this.address = new AddressModel();
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/personal-data/personal-data.model.ts